import { createBrowserHistory } from 'history';

const history = createBrowserHistory({ basename: '/resultados' });

export default history;
